import React, { useEffect, useState } from 'react';
import Header from '../../layouts/Header';
import { Col, Row, Card, Badge, Button, Table, Accordion, Modal, Form, InputGroup, ListGroup, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';
import {
  Clock,
  Calendar,
  CurrencyDollar,
  BoxSeam,
  XCircle,
  CheckCircle,
  CalendarEvent,
  ShopWindow,
  CartPlus,
  CupHot,
  Pencil,
  Trash,
  HourglassSplit,
  ListCheck
} from 'react-bootstrap-icons';
import DeleteConfirmationModal from '../../components/DeleteConfirmationModal';
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useSelector } from 'react-redux';

const ViewSubscription = () => {

    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const accessToken = localStorage.getItem('authToken');
    const animatedComponents = makeAnimated();
    const { access } = useSelector((state) => state.login);
    const { loginEmail } = useSelector((state) => state.login);
    const email = loginEmail || localStorage.getItem("email");
    const [subscriptionAccess, setSubscriptionAccess] = useState([]);
    
    console.log("Access :", access);
    
    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("Subscription:")
            );
            setSubscriptionAccess(filteredAccess);
        } 
    }, [access]);
    
    console.log("Menu Access:", subscriptionAccess);
    
    const [subscriptionList, setSubscriptionList] = useState([]);
    const [activeKey, setActiveKey] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editSubscription, setEditSubscription] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [subscriptionToDelete, setSubscriptionToDelete] = useState(null);
    const [previewImages, setPreviewImages] = useState({
        banner: null,
        otherImage: null
    });
    const [formData, setFormData] = useState({
        title: '',
        subTitle: '',
        description: '',
        termsConditions: [],
        subscriptionWorking: [],
        applicableCategories: [],
        excludedDays: [],
        redemptionInterval: '',
        duration: '',
        price: '',
        taxPercent: '',
        banner: null,
        status: '',
        otherImage: null,
        excludedOutlets: [],
        subscriptionType: '',
        excludedProducts: [],
        excludedAddonValues: [],
        orderThreshold: ''
    });
    const daysOfWeek = [
        'Monday', 'Tuesday', 'Wednesday', 'Thursday',
        'Friday', 'Saturday', 'Sunday'
    ];
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [subscriptionId, setSubscriptionId] = useState('');
    const [newTerm, setNewTerm] = useState('');
    const [newWork, setNewWork] = useState('');

    const [categoryList, setCategoryList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [addonList, setAddonList] = useState([]);
    const [outletList, setOutletList] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);
    const [selectedAddonGroups, setSelectedAddonGroups] = useState([]);

    const addonValueOptions = addonList.flatMap(addon => 
        addon.addonValues.map(value => ({
            value: value._id,          // The addon value ID
            addonId: addon._id,        // The addon group ID
            label: `${addon.title} - ${value.value}`
        }))
    );

    // Fetch subscriptions
    const getSubscriptions = async() => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("subscription", { headers });
            setSubscriptionList(response?.data?.data?.subscriptions);
        } catch (error) {
            toast.error(error.response?.data?.error || "Failed to fetch subscriptions", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        }
    };

    const getCategoryList = async() => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("masters/category/get", { headers });
            console.log("Response :", response);
        
            if (response?.data?.status === true) {
                console.log("Categories Data:", response?.data?.data?.categories);
                const categories = response?.data?.data?.categories;
                console.log("Categories :", categories);
                
                setCategoryList(categories);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                    toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };
  
    const getOutletList = async() => {
      try {
          const headers = {
              Authorization: `Bearer ${accessToken}`,
          };
          const response = await axiosInstance.get("outlet", { headers });
          if (response?.data?.status === true) {
              const filteredOutlets = response?.data?.data?.outlets.filter((act) => act?.status === "ACTIVE");
              setOutletList(filteredOutlets);
          }
      } catch (error) {
          toast.error(error.response?.data?.error || "Failed to fetch outlets", {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
          });
      }
    };
  
    const getProductList = async(categoryIds) => {
      try {
          const headers = {
              Authorization: `Bearer ${accessToken}`,
          };
          const response = await axiosInstance.get("product", { headers });
          // if (response?.data?.status === true) {
          //     setProductList(response?.data?.data?.products);
          // }
          if (response?.data?.status === true) {
              let allProducts = response?.data?.data?.products;

              // Filter products if categoryIds are passed
              allProducts = allProducts?.filter(product =>
                  categoryIds?.includes(product?.category?._id)
              );
              if (allProducts.length > 0 ) {
                  setProductList(allProducts);
              } else {
                  setProductList(response?.data?.data?.products);
              }
          }
      } catch (error) {
          toast.error(error.response?.data?.error || "Failed to fetch products", {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
          });
      }
    };
  
    const getAddonList = async() => {
      try {
          const headers = {
              Authorization: `Bearer ${accessToken}`,
          };
          const response = await axiosInstance.get("addons?page=1&limit=50", { headers });
          if (response?.data?.status === true) {
              setAddonList(response?.data?.data?.addons);
          }
      } catch (error) {
          toast.error(error.response?.data?.error || "Failed to fetch addons", {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
          });
      }
    };

    useEffect(() => {
      getCategoryList();
      getOutletList();
      getProductList();
      getAddonList();
    }, [])

    // Open edit modal and populate form
    const handleEdit = (subscription) => {
        console.log("Subs :", subscription);
        
        // Extract addon groups from excludedAddonValues
        const excludedAddonGroups = subscription?.excludedAddonValues?.map(value => ({
            _id: value.addonId._id,
            title: value.addonId.title,
            addonValues: value.addonId.addonValues
        })) || [];

        // Create filtered addon values options for the select component
        const filteredAddonValues = excludedAddonGroups.flatMap(group => {
            return group.addonValues?.map(val => ({
            value: {
                addonId: group._id,
                addValueId: val._id
            },
            label: `${group.title} - ${val.value}`
            }));
        });

        setEditSubscription(subscription);
        setFormData({
            title: subscription?.title,
            subTitle: subscription?.subTitle,
            description: subscription?.description,
            termsConditions: subscription?.termsConditions || [],
            subscriptionWorking: subscription?.subscriptionWorking || [],
            applicableCategories: subscription?.applicableCategories || [],
            excludedDays: subscription?.excludedDays || [],
            redemptionInterval: subscription?.redemptionInterval,
            duration: subscription?.duration,
            price: subscription?.price,
            status: subscription?.status,
            taxPercent: subscription?.taxPercent,
            subscriptionType: subscription?.subscriptionType,
            banner: null,
            otherImage: null,
            orderQuantity: subscription?.orderQuantity,
            excludedOutlets: subscription?.excludedOutlets || [],
            excludedProducts: subscription?.excludedProducts || [],
            excludedAddonValues: subscription?.excludedAddonValues?.map(val => ({
            addonId: val.addonId._id,
            addValueId: val.addValueId
            })) || [],
            excludedAddonGroups: excludedAddonGroups,
            orderThreshold: subscription?.orderThreshold || ''
        });
        
        // Set the selected addon groups for the UI
        setSelectedAddonGroups(excludedAddonGroups.map(group => ({
            value: group._id,
            label: group.title
        })));

        // Set the filtered addon values options
        setFilteredAddonValues(filteredAddonValues);

        // Set preview images if available
        setPreviewImages({
            banner: subscription?.banner ? subscription?.banner : null,
            otherImage: subscription?.otherImage ? subscription?.otherImage : null
        });
        
        setShowEditModal(true);
    };

    // const handleSelectChange = (fieldName, selectedOptions) => {
    //     if (fieldName === "applicableCategories") {
    //         const catIds = selectedOptions.map(option => option.value); // Extract category IDs
    //         getProductList(catIds); // Pass IDs to filter products
    //     }
    //     console.log("Filed name :", fieldName, "selectedOptions", selectedOptions)
    //     // Convert selected options back to your original objects
    //     let selectedItems = [];
      
    //     if (fieldName === 'applicableCategories') {
    //         selectedItems = selectedOptions 
    //             ? categoryList.filter(category => 
    //                 selectedOptions.some(option => option.value === category._id)
    //             )
    //             : [];
    //     } else if (fieldName === 'excludedOutlets') {
    //         selectedItems = selectedOptions 
    //             ? outletList.filter(outlet => 
    //                 selectedOptions.some(option => option.value === outlet._id)
    //             )
    //             : [];
    //     } else if (fieldName === 'excludedProducts') {
    //         selectedItems = selectedOptions 
    //             ? productList.filter(product => 
    //                 selectedOptions.some(option => option.value === product._id)
    //             )
    //             : [];
    //     } else if (fieldName === 'excludedAddonValues') {
    //         selectedItems = selectedOptions 
    //             ? addonList.filter(addon => 
    //                 selectedOptions.some(option => option.value === addon._id)
    //             )
    //             : [];
    //     }
      
    //     setFormData(prev => ({
    //         ...prev,
    //         [fieldName]: selectedItems
    //     }));
    // };

    const handleSelectChange = (fieldName, selectedOptions) => {
        if (fieldName === "applicableCategories") {
            const catIds = selectedOptions.map(option => option.value); // Extract category IDs
            getProductList(catIds); // Pass IDs to filter products
        }
        console.log("Field name :", fieldName, "selectedOptions", selectedOptions);
        
        // Convert selected options back to your original objects
        let selectedItems = [];
    
        if (fieldName === 'applicableCategories') {
            selectedItems = selectedOptions 
                ? categoryList.filter(category => 
                    selectedOptions.some(option => option.value === category._id)
                )
                : [];
        } else if (fieldName === 'excludedOutlets') {
            selectedItems = selectedOptions 
                ? outletList.filter(outlet => 
                    selectedOptions.some(option => option.value === outlet._id)
                )
                : [];
        } else if (fieldName === 'excludedProducts') {
            selectedItems = selectedOptions 
                ? productList.filter(product => 
                    selectedOptions.some(option => option.value === product._id)
                )
                : [];
        }
    
        setFormData(prev => ({
            ...prev,
            [fieldName]: selectedItems
        }));
    };

    const handleCheckboxChange = (field, value, isChecked) => {
        setFormData(prev => ({
            ...prev,
            [field]: isChecked 
                ? [...prev[field], value] 
                : prev[field].filter(item => item !== value)
        }));
    };

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle file input changes
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: files[0]
        }));
        
        // Create preview URL
        if (files && files[0]) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImages(prev => ({
                    ...prev,
                    [name]: reader.result
                }));
            };
            reader.readAsDataURL(files[0]);
        }
    };

    // Add new term to termsConditions
    const addTerm = () => {
        if (newTerm.trim()) {
            setFormData(prev => ({
                ...prev,
                termsConditions: [...prev.termsConditions, newTerm.trim()]
            }));
            setNewTerm('');
        }
    };

    // Remove term from termsConditions
    const removeTerm = (index) => {
        setFormData(prev => ({
            ...prev,
            termsConditions: prev.termsConditions.filter((_, i) => i !== index)
        }));
    };

    // Add new term to subscription working
    const addWork = () => {
        if (newWork.trim()) {
            setFormData(prev => ({
                ...prev,
                subscriptionWorking: [...prev.subscriptionWorking, newWork.trim()]
            }));
            setNewWork('');
        }
    };

    // Remove term from subscription working
    const removeWork = (index) => {
        setFormData(prev => ({
            ...prev,
            subscriptionWorking: prev.subscriptionWorking.filter((_, i) => i !== index)
        }));
    };

    // Submit edited subscription
    const handleSubmitEdit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const formDataToSend = new FormData();
            
            // Append all form data
            Object.keys(formData).forEach(key => {
                if (
                    key === 'applicableCategories' || 
                    key === 'excludedDays' || 
                    key === 'termsConditions' || 
                    key === 'subscriptionWorking' || 
                    key === 'excludedOutlets' || 
                    key === 'excludedProducts' ||
                    key === 'excludedAddonGroups'  // Added excludedAddonGroups here
                ) {
                    formData[key]?.forEach((item, index) => {
                        const value = typeof item === 'object' && item !== null ? item._id : item;
                        formDataToSend.append(`${key}[${index}]`, value);
                    });
                } 
                else if (key === 'excludedAddonValues') {
                    // Special handling for addon values to include both addonId and addValueId
                    formData[key]?.forEach((item, index) => {
                        formDataToSend.append(`${key}[${index}][addonId]`, item.addonId);
                        formDataToSend.append(`${key}[${index}][addValueId]`, item.addValueId);
                    });
                }
                else if (key === 'banner' || key === 'otherImage') {
                    if (formData[key]) {
                        formDataToSend.append(key, formData[key]);
                    }
                } else {
                    if (formData[key] !== null && formData[key] !== undefined) {
                        formDataToSend.append(key, formData[key]);
                    }
                }
            });

            // Append _id separately if editing
            if (editSubscription?._id) {
                formDataToSend.append('id', editSubscription._id);
            }
            
            const headers = { 
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            };
            
            const response = await axiosInstance.put(`subscription`, formDataToSend, { headers });
            
            toast.success("Subscription updated successfully!", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
            
            setShowEditModal(false);
            getSubscriptions();
        } catch (error) {
            console.error('Error updating subscription:', error);
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if ( error.response?.status === 400 ) {
                    errorMessage = error?.response?.data?.error;
                } else if ( error.response?.status === 500 ) {
                    errorMessage = error?.response?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }   
        
                toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };


    const toggleAccordion = (id) => {
        setActiveKey(activeKey === id ? null : id);
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const handleDeleteClick = (subscription) => {
        setSubscriptionToDelete(subscription);
        console.log("subsrcipytion id :", subscription);
        setSubscriptionId(subscription?._id);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = async(e) => {
      if (subscriptionToDelete) {
        // handleDelete(subscriptionToDelete._id);

        e.preventDefault();
        setIsDeleteLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.delete(
                `subscription?id=${subscriptionId}`,
                { headers }
            );
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setShowDeleteModal(false);
                getSubscriptions();
            }
        } catch (error) {
            if (error.response.status === 403) {
                toast.error(error?.response?.data?.message, {
                  position: "top-right",
                  autoClose: 3000,
                  theme: "colored",
                });
            }
            if (error.response.status === 406) {
                toast.error(error?.response?.data?.message, {
                  position: "top-right",
                  autoClose: 3000,
                  theme: "colored",
                });
            }

            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                  position: "top-right",
                  autoClose: 3000,
                  theme: "colored",
                });
            }
        } finally {
            setIsDeleteLoading(false);
        }

        setShowDeleteModal(false);
        setSubscriptionToDelete(null);
      }
    };

    useEffect(() => {
        getSubscriptions();
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm bg-white rounded-3 p-3 p-lg-3">
                    <Row className="mb-4 align-items-center">
                        <Col>
                            <h4 className="fw-bold mb-0">SUBSCRIPTION MANAGEMENT</h4>
                            <p className="text-muted mb-0">View and manage all subscription plans</p>
                        </Col>
                        <hr className='mt-2 mb-0' />
                    </Row>

                    {subscriptionList?.length === 0 ? (
                        <div className="text-center py-5">
                            <CupHot size={48} className="text-muted mb-3" />
                            <h5>No subscriptions found</h5>
                            <p className="text-muted">Create your first subscription plan to get started</p>
                        </div>
                    ) : (
                        <Row className="g-4">
                            {subscriptionList?.map((subscription) => (
                                <Col key={subscription?._id} xs={12}>
                                    <Card className="border-0 shadow-sm hover-shadow transition-all">
                                        {/* Banner Image at the top of the card */}
                                        {/* {subscription?.banner && (
                                            <div className="banner-container" style={{ height: '150px', overflow: 'hidden' }}>
                                                <img 
                                                    src={subscription.banner} 
                                                    alt="Subscription banner" 
                                                    className="w-100 h-100 object-fit-cover"
                                                    style={{ objectFit: 'cover' }}
                                                />
                                            </div>
                                        )} */}
                                        <Card.Body>
                                            <Row className="align-items-center">
                                                <Col md={3} className="border-end-md">
                                                    <div className="d-flex align-items-center">
                                                        <div className="bg-light rounded p-3 me-3">
                                                            <CupHot size={24} className="text-primary" />
                                                        </div>
                                                        <div>
                                                            <h5 className="mb-1">{subscription?.title}</h5>
                                                            <Badge 
                                                                bg={subscription?.status === "ACTIVE" ? "success" : "secondary"} 
                                                                className="text-capitalize"
                                                            >
                                                                {subscription?.status?.toLowerCase()}
                                                            </Badge>
                                                            <div className="mt-2 d-flex align-items-center">
                                                                {subscription?.subscriptionType === "HOURLY" ? (
                                                                    <>
                                                                        <Clock size={16} className="text-primary me-1" />
                                                                        <span className="text-primary fw-medium">Hourly Plan</span>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Calendar size={16} className="text-warning me-1" />
                                                                        <span className="text-warning fw-medium">Daily Plan</span>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                                
                                                <Col md={6}>
                                                    <div className="d-flex flex-wrap gap-4">
                                                        <div className="d-flex align-items-center">
                                                            <CurrencyDollar className="text-muted me-2" />
                                                            <small className="text-muted">Price:</small>
                                                            <span className="ms-1 fw-semibold">₹{subscription?.price}</span>
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <Calendar className="text-muted me-2" />
                                                            <small className="text-muted">Duration:</small>
                                                            <span className="ms-1 fw-semibold">{subscription?.duration} days</span>
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <Clock className="text-muted me-2" />
                                                            <small className="text-muted">Interval:</small>
                                                            <span className="ms-1 fw-semibold">{subscription?.redemptionInterval} mins</span>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-wrap gap-4 mt-2">
                                                        <div className="d-flex align-items-center">
                                                            <BoxSeam className="text-muted me-2" />
                                                            <small className="text-muted">Order Quantity:</small>
                                                            <span className="ms-1 fw-semibold">{subscription?.orderQuantity}</span>
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <HourglassSplit className="text-muted me-2" />
                                                            <small className="text-muted">Order Threshold:</small>
                                                            <span className="ms-1 fw-semibold">{subscription?.orderThreshold}</span>
                                                        </div>
                                                    </div>
                                                    <p className="mt-2 mb-0 text-muted">{subscription?.description}</p>
                                                </Col>
                                                
                                                <Col md={3} className="text-end">
                                                    {(subscriptionAccess?.includes("Subscritpions:get") || email === "contact@xpansecafe.com") && (
                                                        <Button 
                                                        variant="outline-primary" 
                                                        size="sm" 
                                                        className="me-2"
                                                        onClick={() => 
                                                            toggleAccordion(subscription?._id)
                                                        }
                                                        >
                                                            {activeKey === subscription?._id ? 'Hide Details' : 'View Details'}
                                                        </Button>
                                                    )}
                                                    {(subscriptionAccess?.includes("Subscritpions:update") || email === "contact@xpansecafe.com") && (
                                                        <Button 
                                                            variant="outline-secondary" 
                                                            size="sm"
                                                            className="me-2"
                                                            onClick={() => handleEdit(subscription)}
                                                        >
                                                            <Pencil size={14} className="me-1" /> Edit
                                                        </Button>
                                                    )}
                                                    {(subscriptionAccess?.includes("Subscritpions:delete") || email === "contact@xpansecafe.com") && (
                                                        <Button 
                                                            variant="outline-danger" 
                                                            size="sm"
                                                            onClick={() => handleDeleteClick(subscription)}
                                                        >
                                                            <Trash size={14} className="me-1" /> Delete
                                                        </Button>
                                                    )}
                                                </Col>
                                            </Row>
                                            
                                            <Accordion activeKey={activeKey === subscription._id ? '0' : ''}>
                                                <Accordion.Collapse eventKey="0">
                                                    <div className="mt-3 pt-3 border-top">
                                                        <Row>
                                                            <Col md={6}>
                                                                <h6 className="fw-semibold mb-3">Subscription Details</h6>
                                                                <Table borderless size="sm">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="text-muted" width="40%">Created At:</td>
                                                                            <td>{formatDate(subscription.createdAt)}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-muted">Last Updated:</td>
                                                                            <td>{formatDate(subscription.updatedAt)}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-muted">Subscription Type:</td>
                                                                            <td className="text-capitalize">{subscription.subscriptionType.toLowerCase()}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-muted">Tax Percentage:</td>
                                                                            <td>{subscription.taxPercent}%</td>
                                                                        </tr>
                                                                        {subscription?.applicableCategories?.length > 0 && (
                                                                            <tr>
                                                                                <td className="text-muted">Applicable Categories:</td>
                                                                                <td>
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={
                                                                                            <Tooltip id="categories-tooltip">
                                                                                                {subscription?.applicableCategories?.map(category => category?.name).join(', ')}
                                                                                            </Tooltip>
                                                                                        }
                                                                                    >
                                                                                        <span className="fw-semibold">
                                                                                            {subscription?.applicableCategories?.length} Categories
                                                                                        </span>
                                                                                    </OverlayTrigger>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </Table>
                                                            </Col>
                                                            <Col md={6}>
                                                                <h6 className="fw-semibold mb-3">Restrictions</h6>
                                                                <div className="d-flex flex-wrap gap-3">
                                                                    {subscription?.excludedDays?.length > 0 && (
                                                                        <div className="d-flex align-items-center bg-light rounded p-2">
                                                                            <CalendarEvent className="text-danger me-2" />
                                                                            <small>Excluded Days: {subscription.excludedDays.join(', ')}</small>
                                                                        </div>
                                                                    )}
                                                                    {subscription?.excludedOutlets?.length > 0 && (
                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={
                                                                            <Tooltip id="outlets-tooltip">
                                                                                {subscription.excludedOutlets.map(outlet => outlet.name).join(', ')}
                                                                            </Tooltip>
                                                                            }
                                                                        >
                                                                            <div className="d-flex align-items-center bg-light rounded p-2">
                                                                            <ShopWindow className="text-danger me-2" />
                                                                            <small>{subscription.excludedOutlets?.length} Outlets Excluded</small>
                                                                            </div>
                                                                        </OverlayTrigger>
                                                                    )}
                                                                    {subscription?.excludedProducts?.length > 0 && (
                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={
                                                                            <Tooltip id="products-tooltip">
                                                                                {subscription?.excludedProducts?.map(product => product.name).join(', ')}
                                                                            </Tooltip>
                                                                            }
                                                                        >
                                                                            <div className="d-flex align-items-center bg-light rounded p-2">
                                                                            <CartPlus className="text-danger me-2" />
                                                                            <small>{subscription?.excludedProducts?.length} Products Excluded</small>
                                                                            </div>
                                                                        </OverlayTrigger>
                                                                    )}
                                                                    {subscription?.excludedAddonGroups?.length > 0 && (
                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={
                                                                                <Tooltip id="addon-groups-tooltip">
                                                                                    {subscription?.excludedAddonGroups?.map(group => group.title).join(', ')}
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <div className="d-flex align-items-center bg-light rounded p-2">
                                                                                <ListCheck className="text-danger me-2" />
                                                                                <small>{subscription?.excludedAddonGroups?.length} Addon Groups Excluded</small>
                                                                            </div>
                                                                        </OverlayTrigger>
                                                                    )}
                                                                    {subscription?.excludedAddonValues?.length > 0 && (
                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={
                                                                                <Tooltip id="addon-values-tooltip">
                                                                                    {subscription?.excludedAddonValues?.map(val => {
                                                                                        // Use the nested addonId object that contains the group info
                                                                                        const group = val.addonId;
                                                                                        // Find the specific value in the group's addonValues
                                                                                        const value = group?.addonValues?.find(v => v._id === val.addValueId);
                                                                                        
                                                                                        return `${group?.title || 'Unknown'} - ${value?.value || 'Unknown'}`;
                                                                                    }).join(', ')}
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <div className="d-flex align-items-center bg-light rounded p-2">
                                                                                <ListCheck className="text-danger me-2" />
                                                                                <small>{subscription?.excludedAddonValues?.length} Addon Values Excluded</small>
                                                                            </div>
                                                                        </OverlayTrigger>
                                                                    )}
                                                                </div>
                                                            
                                                                <h6 className="fw-semibold mt-3 mb-2">Terms & Conditions</h6>
                                                                <ul className="list-unstyled small">
                                                                    {subscription?.termsConditions?.map((term, index) => (
                                                                    <li key={index} className="mb-1">
                                                                        <CheckCircle className="text-success me-2" size={14} />
                                                                        {term}
                                                                    </li>
                                                                    ))}
                                                                </ul>
                                                            
                                                                <h6 className="fw-semibold mt-3 mb-2">How Does It Works</h6>
                                                                <ul className="list-unstyled small">
                                                                    {subscription?.subscriptionWorking?.map((work, index) => (
                                                                    <li key={index} className="mb-1">
                                                                        <CheckCircle className="text-success me-2" size={14} />
                                                                        {work}
                                                                    </li>
                                                                    ))}
                                                                </ul>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Accordion.Collapse>
                                            </Accordion>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    )}
                </div>
            </div>

            {/* Edit Subscription Modal */}
            <Modal 
              show={showEditModal} 
              onHide={() => setShowEditModal(false)} 
              size="xl"
              centered
              backdrop="static"
            >
              <Modal.Header closeButton className="border-bottom-0 pb-0">
                <Modal.Title className="h4 fw-semibold text-primary">UPDATE SUBSCRIPTION PLAN</Modal.Title>
              </Modal.Header>
              <hr />
              
              <Modal.Body className="pt-1">
                <Form onSubmit={handleSubmitEdit}>
                  {/* Section 1: Basic Information */}
                  <div className="mb-4">
                    <h6 className="mb-3 text-muted fw-semibold">BASIC INFORMATION</h6>
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group controlId="title">
                          <Form.Label className="fw-semibold">Title<span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleInputChange}
                            required
                            className="py-2"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="subTitle">
                          <Form.Label className="fw-semibold">Subtitle <span className='text-danger'>*</span></Form.Label>
                          <Form.Control
                            type="text"
                            name="subTitle"
                            value={formData.subTitle}
                            onChange={handleInputChange}
                            className="py-2"
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} lg={6}>
                        <Form.Group controlId="description">
                          <Form.Label className="fw-semibold">Description <span className='text-danger'>*</span></Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            className="py-2"
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="6" lg="3">
                          <Form.Label className="fw-semibold">
                              Subscription Type <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Select className='w-100' id="subscriptionType" name="subscriptionType" value={formData?.subscriptionType} onChange={handleInputChange}>
                              <option value="" disabled>Select Subscription Type</option>
                              <option value="DAILY">DAILY</option>
                              <option value="HOURLY">HOURLY</option>
                          </Form.Select>
                      </Col>
                      <Col xs="6" lg="3">
                          <Form.Label className="fw-semibold">
                              Status <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Select className='w-100' id="status" name="status" value={formData?.status} onChange={handleInputChange}>
                              <option value="" disabled>Select Status</option>
                              <option value="ACTIVE">ACTIVE</option>
                              <option value="INACTIVE">INACTIVE</option>
                          </Form.Select>
                      </Col>
                    </Row>
                    {/* Section 3: Terms & Conditions And How It Works */}
                    <Row className="mt-3">
                      <Col>
                          <Form.Group className="mb-3">
                              <Form.Label className='fw-semibold'>How Does It Works <span className='text-danger'>*</span></Form.Label>
                              
                              <div className="mb-3">
                                  <div className="input-group">
                                      <Form.Control
                                          type="text"
                                          placeholder="Add the workings of the subscription"
                                          value={newWork}
                                          onChange={(e) => setNewWork(e.target.value)}
                                      />
                                      <Button variant="primary" onClick={addWork}>
                                          Add
                                      </Button>
                                  </div>
                              </div>
                              
                              {formData?.subscriptionWorking?.length > 0 && (
                                  <ListGroup>
                                      {formData?.subscriptionWorking?.map((work, index) => (
                                          <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                                              {work}
                                              <Button 
                                                  variant="outline-danger" 
                                                  size="sm" 
                                                  onClick={() => removeWork(index)}
                                              >
                                                  Remove
                                              </Button>
                                          </ListGroup.Item>
                                      ))}
                                  </ListGroup>
                              )}
                          </Form.Group>
                      </Col>
                      <Col>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Terms & Conditions <span className='text-danger'>*</span></Form.Label>
                            <div className="d-flex mb-2">
                              <Form.Control
                                type="text"
                                value={newTerm}
                                onChange={(e) => setNewTerm(e.target.value)}
                                placeholder="Enter term..."
                                className="py-2"
                              />
                              <Button 
                                variant="outline-primary" 
                                onClick={addTerm} 
                                className="ms-2 px-4"
                                disabled={!newTerm.trim()}
                              >
                                Add
                              </Button>
                            </div>
                            <div className="border rounded p-3 bg-light" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                              {formData.termsConditions.length > 0 ? (
                                <ListGroup variant="flush">
                                  {formData.termsConditions.map((term, index) => (
                                    <ListGroup.Item key={index} className ="d-flex justify-content-between align-items-center px-0 py-2">
                                      <span className="text-break">{term}</span>
                                      <Button 
                                        variant="link" 
                                        size="sm" 
                                        onClick={() => removeTerm(index)}
                                        className="text-danger p-0"
                                        aria-label="Remove term"
                                      >
                                        <i className="bi bi-x-lg"></i>
                                      </Button>
                                    </ListGroup.Item>
                                  ))}
                                </ListGroup>
                              ) : (
                                <div className="text-center text-muted py-3">No terms added yet</div>
                              )}
                            </div>
                          </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  <hr />

                  {/* Section 2: Pricing & Duration */}
                  <div className="mb-4">
                    <h6 className="mb-3 text-muted fw-semibold">PRICING & DURATION</h6>
                    <Row className="g-3">
                      <Col md={4}>
                        <Form.Group controlId="price">
                          <Form.Label className="fw-medium">Price (₹)<span className="text-danger">*</span></Form.Label>
                          <InputGroup>
                            <InputGroup.Text>₹</InputGroup.Text>
                            <Form.Control
                              type="number"
                              min="0"
                              step="0.01"
                              name="price"
                              value={formData.price}
                              onChange={handleInputChange}
                              required
                              className="py-2"
                            />
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="duration">
                          <Form.Label className="fw-semibold">Duration (days)<span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="number"
                            min="1"
                            step="any"
                            name="duration"
                            value={formData.duration}
                            onChange={handleInputChange}
                            required
                            className="py-2"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="redemptionInterval">
                          <Form.Label className="fw-semibold">Redemption Interval (mins)<span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="number"
                            step="any"
                            name="redemptionInterval"
                            value={formData.redemptionInterval}
                            onChange={handleInputChange}
                            required
                            className="py-2"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="taxPercent">
                          <Form.Label className="fw-semibold">Tax (%)<span className="text-danger">*</span></Form.Label>
                          <InputGroup>
                            <Form.Control
                                type="number"
                                min="0"
                                max="100"
                                step="any"
                                name="taxPercent"
                                value={formData.taxPercent}
                                onChange={handleInputChange}
                                required
                                className="py-2"
                            />
                            <InputGroup.Text>%</InputGroup.Text>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                          <Form.Group className="mb-3">
                              <Form.Label className='fw-semibold'>Order Quantity <span className='text-danger'>*</span></Form.Label>
                              <Form.Control
                                  type="number"
                                  min="0"
                                  step="any"
                                  name="orderQuantity"
                                  placeholder="Enter maximum orders a user can place (0 = no limit)"
                                  value={formData.orderQuantity}
                                  onChange={handleInputChange}
                              />
                          </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="orderThreshold">
                          <Form.Label className="fw-semibold">Order Threshold</Form.Label>
                          <Form.Control
                            type="number"
                            min="0"
                            name="orderThreshold"
                            value={formData.orderThreshold}
                            onChange={handleInputChange}
                            placeholder="Enter minimum orders required (0 = no limit)"
                            className="py-2"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  <hr />
                  {/* Section 3: Terms & Conditions */}
                  {/* <div className="mb-4">
                    <h6 className="mb-3 text-muted fw-semibold">TERMS & CONDITIONS</h6>
                    <Form.Group>
                      <Form.Label className="fw-medium">Add Terms</Form.Label>
                      <div className="d-flex mb-2">
                        <Form.Control
                          type="text"
                          value={newTerm}
                          onChange={(e) => setNewTerm(e.target.value)}
                          placeholder="Enter term..."
                          className="py-2"
                        />
                        <Button 
                          variant="outline-primary" 
                          onClick={addTerm} 
                          className="ms-2 px-4"
                          disabled={!newTerm.trim()}
                        >
                          Add
                        </Button>
                      </div>
                      <div className="border rounded p-3 bg-light" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                        {formData.termsConditions.length > 0 ? (
                          <ListGroup variant="flush">
                            {formData.termsConditions.map((term, index) => (
                              <ListGroup.Item key={index} className ="d-flex justify-content-between align-items-center px-0 py-2">
                                <span className="text-break">{term}</span>
                                <Button 
                                  variant="link" 
                                  size="sm" 
                                  onClick={() => removeTerm(index)}
                                  className="text-danger p-0"
                                  aria-label="Remove term"
                                >
                                  <i className="bi bi-x-lg"></i>
                                </Button>
                              </ListGroup.Item>
                            ))}
                          </ListGroup>
                        ) : (
                          <div className="text-center text-muted py-3">No terms added yet</div>
                        )}
                      </div>
                    </Form.Group>
                  </div> */}

                  {/* Section 4: Applicability */}
                  <div className="mb-4">
                    <h6 className="mb-3 text-muted fw-semibold">APPLICABILITY</h6>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label className='fw-semibold'>Applicable Categories <span className='text-danger'>*</span></Form.Label>
                                <Select
                                    components={animatedComponents}
                                    isMulti
                                    options={categoryList?.map(category => ({
                                        value: category?._id,
                                        label: category?.name
                                    }))}
                                    value={formData?.applicableCategories?.map(cat => ({
                                        value: cat._id,
                                        label: cat.name
                                    }))}
                                    onChange={(selectedOptions) => handleSelectChange('applicableCategories', selectedOptions)}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Select categories..."
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label className='fw-semibold'>Exclude Products</Form.Label>
                                <Select
                                    components={animatedComponents}
                                    isMulti
                                    options={productList?.map(product => ({
                                        value: product?._id,
                                        label: product?.name
                                    }))}
                                    value={formData?.excludedProducts?.map(product => ({
                                        value: product._id,
                                        label: product.name
                                    }))}
                                    onChange={(selectedOptions) => handleSelectChange('excludedProducts', selectedOptions)}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Select products to exclude..."
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label className='fw-semibold'>Exclude Addon Groups</Form.Label>
                                <Select
                                    components={animatedComponents}
                                    isMulti
                                    options={addonList.map(addon => ({
                                    value: addon._id,
                                    label: addon.title
                                    }))}
                                    value={formData.excludedAddonGroups?.map(group => ({
                                    value: group._id,
                                    label: group.title
                                    }))}
                                    onChange={(selectedOptions) => {
                                    // Update selected addon groups
                                    const selectedGroups = addonList.filter(addon => 
                                        selectedOptions?.some(option => option.value === addon._id)
                                    );
                                    
                                    setFormData(prev => ({
                                        ...prev,
                                        excludedAddonGroups: selectedGroups || []
                                    }));

                                    // Generate addon values options based on selected groups
                                    const addonValuesOptions = selectedGroups?.flatMap(group => {
                                        return group.addonValues?.map(val => ({
                                        value: {
                                            addonId: group._id,
                                            addValueId: val._id
                                        },
                                        label: `${group.title} - ${val.value}`
                                        }));
                                    });

                                    setFilteredAddonValues(addonValuesOptions || []);
                                    }}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Select addon groups to exclude..."
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label className='fw-semibold'>Exclude Addon Values</Form.Label>
                                <Select
                                    components={animatedComponents}
                                    isMulti
                                    options={filteredAddonValues}
                                    value={formData.excludedAddonValues?.map(val => ({
                                    value: val,
                                    label: `${addonList.find(a => a._id === val.addonId)?.title || ''} - ${
                                        addonList
                                        .find(a => a._id === val.addonId)
                                        ?.addonValues.find(v => v._id === val.addValueId)?.value || ''
                                    }`
                                    }))}
                                    onChange={(selectedOptions) => {
                                    setFormData(prev => ({
                                        ...prev,
                                        excludedAddonValues: selectedOptions?.map(option => option.value) || []
                                    }));
                                    }}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Select addon values to exclude..."
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => `${option.value.addonId}-${option.value.addValueId}`}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label className='fw-semibold'>Exclude Outlets</Form.Label>
                                <Select
                                    components={animatedComponents}
                                    isMulti
                                    options={outletList?.map(outlet => ({
                                        value: outlet?._id,
                                        label: outlet?.name
                                    }))}
                                    value={formData?.excludedOutlets?.map(outlet => ({
                                        value: outlet._id,
                                        label: outlet.name
                                    }))}
                                    onChange={(selectedOptions) => handleSelectChange('excludedOutlets', selectedOptions)}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Select outlets to exclude..."
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label className='fw-semibold'>Exclude Days (Optional)</Form.Label>
                                <div className="d-flex flex-wrap gap-2">
                                    {daysOfWeek.map(day => (
                                        <Form.Check
                                            key={day}
                                            type="checkbox"
                                            id={`day-${day}`}
                                            label={day}
                                            checked={formData.excludedDays.includes(day)}
                                            onChange={(e) => handleCheckboxChange('excludedDays', day, e.target.checked)}
                                        />
                                    ))}
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                  </div>

                  <hr />

                  {/* Section 4: Images */}
                  <div className="mb-4">
                    <h6 className="mb-3 text-muted fw-semibold">IMAGES</h6>
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group controlId="banner">
                          <Form.Label className="fw-semibold">Banner Image <span className='text-danger'>*</span></Form.Label>
                          <Form.Control
                            type="file"
                            name="banner"
                            onChange={handleFileChange}
                            accept="image/*"
                            className="py-2"
                          />
                          {previewImages?.banner && (
                            <div className="mt-3 text-center">
                              <h6 className="small text-muted">Preview</h6>
                              <img 
                                src={previewImages?.banner} 
                                alt="Banner preview" 
                                className="img-fluid rounded border" 
                                style={{ maxHeight: '120px' }}
                              />
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="otherImage">
                          <Form.Label className="fw-semibold">Other Image</Form.Label>
                          <Form.Control
                            type="file"
                            name="otherImage"
                            onChange={handleFileChange}
                            accept="image/*"
                            className="py-2"
                          />
                          {previewImages.otherImage && (
                            <div className="mt-3 text-center">
                              <h6 className="small text-muted">Preview</h6>
                              <img 
                                src={previewImages.otherImage} 
                                alt="Other image preview" 
                                className="img-fluid rounded border" 
                                style={{ maxHeight: '120px' }}
                              />
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  {/* Footer Buttons */}
                  <div className="d-flex justify-content-end gap-3 pt-3 border-top">
                    <Button
                      variant="outline-secondary" 
                      onClick={() => setShowEditModal(false)} 
                      className="px-4"
                    >
                      Cancel
                    </Button>
                    <Button 
                      variant="primary" 
                      type="submit"
                      className="px-4"
                    >
                      { isEditBtnLoading ? <Spinner size='sm'/> : "Save Changes" }
                    </Button>
                  </div>
                </Form>
              </Modal.Body>
            </Modal>

            {/* Delete Subscription Modal */}
            <DeleteConfirmationModal
              show={showDeleteModal}
              onHide={() => setShowDeleteModal(false)}
              onConfirm={handleConfirmDelete}
              loading={isDeleteLoading}
              title={`Delete "${subscriptionToDelete?.title}"?`}
              message={`You're about to permanently delete the "${subscriptionToDelete?.title}" subscription and all its data. This action cannot be undone.`}
            />
        </React.Fragment>
    );
};

export default ViewSubscription;